/* eslint-disable indent */
/* eslint-disable @typescript-eslint/indent */
import { Crate } from '@piwikpro/platform';
import HttpCrate from '@piwikpro/http-crate';
import NotificationCrate from '@piwikpro/notification-crate';
import FormCrate from '@piwikpro/form-crate';
import ScrollTracking from './components/ScrollTracking';
import SpaTracking from './components/SpaTracking';
import CookiesSection from './components/CookiesSection';
import { ContainerSettings } from './ContainerSettings';
import containerSettings from './redux';

@Crate({
  name: 'ContainerSettingsCrate',
  imports: [
    HttpCrate,
    NotificationCrate,
    FormCrate,
  ],
  services: [
    { name: 'ContainerSettings', provide: ContainerSettings },
  ],
  components: [
    { name: 'ScrollTracking', provide: ScrollTracking },
    { name: 'SpaTracking', provide: SpaTracking },
    { name: 'CookiesSection', provide: CookiesSection },
  ],
  reducers: {
    containerSettings,
  },
})
export class ContainerSettingsCrate {}
